// Mirrors InvitationProgressResponse in avm-api
export interface InvitationProgress {
    webform?: {
        status: WebformStatus;
        updatedOn: string;
    };
    payment?: {
        status: PaymentStatus;
        paidOn?: string;
        amountVatInclusive?: number | string;
        unsuccessfulAttempts: number;
    };
    nsxSync?: {
        status: NsxSyncStatus;
        createdOn: string;
        updatedOn: string;
        retryCount: number;
        maxRetryCount: number;
        // only filled in for admins
        error?: string;
    };
    nsxEnabled: boolean;
}

export enum WebformStatus {
    NEW = 'NEW',
    COMPLETED = 'COMPLETED',
}

export enum PaymentStatus {
    Open = 'open',
    Paid = 'paid',
}

export enum NsxSyncStatus {
    NEW = 'NEW',
    CREATED = 'CREATED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
}
